import axios from '../../../helpers/custom-axios';
import { notify, confirmation } from '../../../helpers/notifications';

export async function copyResponseFile(response_id, response_file_id) {
  return axios
    .post(`/manage/responses/${response_id}/copy_file`, {
      source_id: response_file_id,
    })
    .then((res) => {
      notify.success('File Copied');
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
}

export async function createResponseFile(responseId, htmlForm) {
  let form = new FormData(htmlForm);
  return axios
    .post(`/manage/responses/${responseId}/add_file`, form, {
      headers: { processData: false, contentType: false, cache: false },
    })
    .then((res) => {
      notify.success('File uploaded');
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
}

export async function updateResponseFile(responseFileId, newName) {
  return axios
    .put(`/manage/response_files/${responseFileId}`, {
      response_file: { filename: newName },
    })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
}

export async function destroyResponseFile(responseFileId, callback) {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/response_files/${responseFileId}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
}

export async function createResponseOption(responseId, optionId) {
  let response_option = { response_id: responseId, option_id: optionId };
  return axios
    .post('/manage/response_options', { response_option })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
}

export async function destroyResponseOption(responseOptionId) {
  return axios
    .delete(`/manage/response_options/${responseOptionId}`)
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
}

export async function updateResponseOption(responseOptionId, optionId) {
  return axios
    .put(`/manage/response_options/${responseOptionId}`, {
      response_option: { option_id: optionId },
    })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
}

export async function updateResponse(responseId, value) {
  return axios
    .put(`/manage/responses/${responseId}`, {
      response: { value },
    })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
}

export async function createResponse(submissionId, fieldId, value) {
  return axios
    .post('/manage/responses', {
      response: {
        field_id: fieldId,
        submission_id: submissionId,
        value: value ? value : null,
      },
    })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
}

export const fillDummyResponses = (
  submission,
  filterableResponses,
  filterFields
) => {
  // Currently need to insert dummy response if submission does not have a response for the field... the issue *should* be solved with clean data
  let responseArray = [...filterableResponses];
  let missingResponsesForFields = filterFields
    .map((ff) => ff.field_id)
    .filter((n) => !filterableResponses.map((r) => r.field_id).includes(n));

  missingResponsesForFields.forEach((fieldId, index) => {
    responseArray.push({
      id: `missing-${submission.id}-field-${fieldId}`,
      field_id: fieldId,
      submission_id: submission.id,
      value: '',
      response_options: [],
      response_files: [],
    });
  });

  return orderResponses(responseArray, filterFields);
};

export const orderResponses = (responseArray, filterFields) => {
  // the only method needed with clean data:
  let orderedResponses = responseArray.sort((a, b) => {
    let sortA = filterFields.find((ff) => a.field_id === ff.field_id).sort;
    let sortB = filterFields.find((ff) => b.field_id === ff.field_id).sort;
    return sortA - sortB;
  });

  // filter out duplicate responses from response bug
  return orderedResponses.filter(
    (r, i, a) => a.findIndex((r2) => r2.field_id === r.field_id) === i
  );
};

export const batchUpdate = async (params) => {
  let path = '/manage/submissions/update_all?' + params;
  $('.opaque-spinner-bg').css('display', 'flex');
  $('body').css('pointer-events', 'none');

  return axios
    .get(path)
    .then((res) => {
      let count = res.data.update_count;
      notify.alertSuccess(
        'Batch Update Successful',
        `Update affected ${count} submissions.`
      );
      return res;
    })
    .catch((error) => {
      notify.alertFailure('Uh oh!', 'Something went wrong...');
      return error;
    })
    .finally(() => {
      $('.opaque-spinner-bg').css('display', 'none');
      $('body').css('pointer-events', 'auto');
    });
};

export const textBatchUpdate = async (params) => {
  let path = '/manage/submissions/find_and_replace?' + params;
  $('.opaque-spinner-bg').css('display', 'flex');
  $('body').css('pointer-events', 'none');

  return axios
    .get(path)
    .then((res) => {
      let count = res.data.update_count;
      notify.alertSuccess(
        'Batch Update Successful',
        `Update affected ${count} submissions.`
      );
      return res;
    })
    .catch((error) => {
      notify.alertFailure('Uh oh!', 'Something went wrong...');
      return error;
    })
    .finally(() => {
      $('.opaque-spinner-bg').css('display', 'none');
      $('body').css('pointer-events', 'auto');
    });
};
